import './contact.scss'
import React from 'react'
import MailchimpSubscribe from 'react-mailchimp-subscribe'
import { Container, Grid, Typography } from '@material-ui/core'
import {
  Email,
  LocationOn,
  Twitter,
  Instagram,
  LinkedIn
} from '@material-ui/icons'
import MakesBetter from 'components/MakesBetter'
import SubscribeForm from './SubscribeForm'
import QueryWrapper from 'components/querywrapper'
import { useLocale } from 'hooks'
import useSwr from 'swr'
import * as qs from 'qs'
const {
  REACT_APP_STRAPI_API_URL,
  REACT_APP_MAILCHIMP_API,
  REACT_APP_MAILCHIMP_U,
  REACT_APP_MAILCHIMP_ID
} = process.env

const url = `${REACT_APP_MAILCHIMP_API}?u=${REACT_APP_MAILCHIMP_U}&id=${REACT_APP_MAILCHIMP_ID}`

function Contact() {
  const { locale } = useLocale()
  const query = qs.stringify({
    populate: '*',
    locale: [locale]
  })
  const fetcher = () =>
    fetch(`${REACT_APP_STRAPI_API_URL}/api/contact-infos?${query}`).then(res =>
      res.json()
    )
  const { data: contactInfo, isError } = useSwr(
    ['/api/contact-page', locale],
    fetcher
  )

  return (
    <QueryWrapper loading={!contactInfo && !isError} error={isError}>
      <div className="contactPage">
        <Container>
          <Grid item xs={12}>
            <Grid container item xl={12}>
              <div className="contactinfo">
                <Typography variant="h1">
                  {contactInfo?.data[0]?.attributes.title}
                </Typography>
                <Typography component="p">
                  {contactInfo?.data[0]?.attributes.content}
                </Typography>
              </div>
            </Grid>
            <Grid
              container
              item
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
              className="contactForm"
            >
              <div className="contactFormDetails">
                <MailchimpSubscribe
                  url={url}
                  render={({ subscribe, status, message }) => (
                    <SubscribeForm
                      status={status}
                      message={message}
                      onValidated={subscribe}
                      nameInput={contactInfo?.data[0]?.attributes.NameInput}
                      emailInput={contactInfo?.data[0]?.attributes.EmailInput}
                      messageInput={
                        contactInfo?.data[0]?.attributes.MessageInput
                      }
                      submitButton={
                        contactInfo?.data[0]?.attributes.SubmitButton
                      }
                      sendingButton={
                        contactInfo?.data[0]?.attributes.SendingButton
                      }
                    />
                  )}
                />
              </div>
            </Grid>
            <Grid
              container
              item
              xl={3}
              lg={3}
              md={3}
              sm={12}
              xs={12}
              className="contact-detail-warp"
            >
              <div className="contactdeatil">
                <div className="contdetailcol1">
                  <Email />
                  <Typography variant="h4">
                    {contactInfo?.data[0]?.attributes.contactEmail}
                  </Typography>
                </div>
                <div className="contdetailcol1">
                  <LocationOn />
                  <Typography variant="h5">
                    {contactInfo?.data[0]?.attributes.contactAddress}
                  </Typography>
                </div>
                <div className="contactIcon">
                  <a
                    href="https://www.linkedin.com/company/web3-domains/"
                    target="_blank"
                  >
                    <LinkedIn />
                  </a>
                  <a
                    href="https://instagram.com/theweb3domains"
                    target="_blank"
                  >
                    <Instagram />
                  </a>
                  <a href="https://twitter.com/theweb3domains" target="_blank">
                    <Twitter />
                  </a>
                </div>
                <div className="contdetailcol1">
                  <img
                    src={
                      REACT_APP_STRAPI_API_URL +
                      contactInfo?.data[0]?.attributes?.Image?.data[0]
                        ?.attributes?.url
                    }
                    alt="contact"
                    className="img-fluid"
                  />
                </div>
              </div>
            </Grid>
            <Grid container item xl={3} lg={3} md={3} sm={12} xs={12} />
          </Grid>
        </Container>
        <Container className="mapwrap">
          <Grid item xs={12}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28899.024181177687!2d55.35272870626808!3d25.122907538794646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f640f1dcd4111%3A0xcb38e7be624792c3!2sDubai%20Silicon%20Oasis%20-%20Dubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sin!4v1653022691362!5m2!1sen!2sin"
              width="1280"
              height="314"
              frameBorder="0"
              allowFullScreen=""
            />
          </Grid>
        </Container>

        <Container>
          <Grid item xs={12}>
            <MakesBetter style={{ marginTop: 94 }} />
          </Grid>
        </Container>
      </div>
    </QueryWrapper>
  )
}

export default Contact
